export default {"src":"https://cdn.seaya.az/dist//_next/static/media/next.b39643f6.svg","height":22,"width":15,"blurWidth":0,"blurHeight":0};